import { useContext } from 'react';
import { GlobalToastContext } from '../GlobalToastProvider';

/**
 * Gives access to the global Toast ref from anywhere inside GlobalToastProvider.
 *
 * @example
 * const globalToastRef = useGlobalToast();
 * globalToastRef.current?.show({ severity: 'success', summary: 'Success', detail: 'Done' });
 */

export const useGlobalToast = () => {
  const context = useContext(GlobalToastContext);
  if (!context) {
    throw new Error('useGlobalToast must be used within a ToastProvider');
  }
  return context.toastRef;
};
